import Container from "../../shared/ui/Container";
import "./PrivacyPolicy.scss";

export default function PrivacyPolicy() {
  return (
    <div className="privacy">
      <section className="page-header" aria-labelledby="page-title">
        <Container>
          <h1 id="page-title" className="page-header__title">
            Privacy Policy
          </h1>
          <p className="page-header__subtitle">Last updated: [17 November 2025]</p>
        </Container>
      </section>

        <section className="privacy-section" aria-labelledby="privacy-section-title">
          <h2 className="privacy-section__title">1. Information We Collect</h2>

          <p className="privacy-section__text">
            We only collect personal information that you voluntarily provide
            through our contact form:
          </p>

          <ul className="privacy-section__list">
            <li className="privacy-section__list-item">Name</li>
            <li className="privacy-section__list-item">Email address</li>
            <li className="privacy-section__list-item">Message</li>
          </ul>

          <p className="privacy-section__text">
            We do not collect payment information, sensitive personal data, or
            any additional details unless you choose to provide them.
          </p>

          <p className="privacy-section__text">
            We may also automatically receive non-personally identifiable
            technical information such as:
          </p>

          <ul className="privacy-section__list">
            <li className="privacy-section__list-item">browser type</li>
            <li className="privacy-section__list-item">device type</li>
            <li className="privacy-section__list-item">
              basic analytics data
            </li>
          </ul>
        </section>

        <section className="privacy-section" aria-labelledby="privacy-section-title">
          <h2 className="privacy-section__title">2. How We Use Your Information</h2>

          <ul className="privacy-section__list">
            <li className="privacy-section__list-item">
              To respond to your inquiries and provide requested services.
            </li>
            <li className="privacy-section__list-item">
              To send an automatic confirmation email after form submission.
            </li>
            <li className="privacy-section__list-item">
              For internal record-keeping and communication with potential
              clients.
            </li>
            <li className="privacy-section__list-item">
              To improve our services and customer support.
            </li>
          </ul>

          <p className="privacy-section__text">
            We do not sell, rent, or trade your personal information.
          </p>
        </section>

        <section className="privacy-section" aria-labelledby="privacy-section-title">
          <h2 className="privacy-section__title">3. Where Your Data Is Stored</h2>

          <p className="privacy-section__text">
            Your submitted form may be stored or processed using:
          </p>

          <ul className="privacy-section__list">
            <li className="privacy-section__list-item">
              <strong>Microsoft services</strong> (Outlook or related email
              tools) — used for sending and receiving your emails.
            </li>
            <li className="privacy-section__list-item">
              <strong>MongoDB Atlas</strong> — a secure cloud database service.
            </li>
          </ul>

          <p className="privacy-section__text">
            Both providers comply with industry security standards and
            international data protection requirements.
          </p>
        </section>

        <section className="privacy-section" aria-labelledby="privacy-section-title">
          <h2 className="privacy-section__title">4. Sharing Your Information</h2>

          <p className="privacy-section__text">
            We only share your information with third-party service providers
            that help us operate our business, such as:
          </p>

          <ul className="privacy-section__list">
            <li className="privacy-section__list-item">
              Microsoft (email services)
            </li>
            <li className="privacy-section__list-item">
              MongoDB (database hosting)
            </li>
          </ul>

          <p className="privacy-section__text">
            These providers are obligated to protect your data and cannot use it
            for their own marketing purposes.
          </p>

          <p className="privacy-section__text">
            We do not share your information with advertisers or unrelated third
            parties.
          </p>
        </section>

        <section className="privacy-section" aria-labelledby="privacy-section-title">
          <h2 className="privacy-section__title">5. Data Retention</h2>

          <p className="privacy-section__text">
            We retain personal information only for as long as necessary to:
          </p>

          <ul className="privacy-section__list">
            <li className="privacy-section__list-item">communicate with you,</li>
            <li className ="privacy-section__list-item">
              provide requested services,
            </li>
            <li className="privacy-section__list-item">
              maintain business records required by law.
            </li>
          </ul>

          <p className="privacy-section__text">
            You may request deletion of your data at any time.
          </p>
        </section>

        <section className="privacy-section" aria-labelledby="privacy-section-title">
          <h2 className="privacy-section__title">6. Your Rights</h2>

          <p className="privacy-section__text">
            As a resident of Canada, you have the right to:
          </p>

          <ul className="privacy-section__list">
            <li className="privacy-section__list-item">
              Request access to the personal information we hold about you.
            </li>
            <li className="privacy-section__list-item">
              Ask us to correct or delete your information.
            </li>
            <li className="privacy-section__list-item">
              Withdraw your consent at any time.
            </li>
          </ul>

          <p className="privacy-section__text">
            To exercise these rights, contact us at:{" "}
            <strong>[contactus@dafi.ca]</strong>
          </p>

          <p className="privacy-section__text">
            We will respond within 2–5 business days.
          </p>
        </section>

        <section className="privacy-section" aria-labelledby="privacy-section-title">
          <h2 className="privacy-section__title">7. Data Security</h2>

          <p className="privacy-section__text">
            We take reasonable technical and organizational measures to protect
            your data, including:
          </p>

          <ul className="privacy-section__list">
            <li className="privacy-section__list-item">
              encrypted connections (HTTPS),
            </li>
            <li className="privacy-section__list-item">secure email systems,</li>
            <li className="privacy-section__list-item">
              access-controlled storage,
            </li>
            <li className="privacy-section__list-item">
              regularly updated security practices.
            </li>
          </ul>

          <p className="privacy-section__text">
            However, no method of transmission over the internet is 100% secure.
          </p>
        </section>

        <section className="privacy-section" aria-labelledby="privacy-section-title">
          <h2 className="privacy-section__title">8. Changes to This Policy</h2>
          <p className="privacy-section__text">
            We may update this Privacy Policy periodically. Any changes will be
            posted on this page with an updated revision date.
          </p>
        </section>

        <section className="privacy-section" aria-labelledby="privacy-section-title">
          <h2 className="privacy-section__title">9. Contact Information</h2>
          <p className="privacy-section__text">
            If you have any questions about this Privacy Policy or the way we
            handle your information, please contact us at: contactus@dafi.ca
          </p>
        </section>
    </div>
  );
}
